<template>
  <v-row justify="center">
    <v-col cols="12" sm="10" md="8" lg="6">
      <v-card ref="form">
        <v-card-text class="text-center">
          <v-card-title>
            Enter email to reset password.
          </v-card-title>
          <v-divider></v-divider>
          <v-text-field
            class="mt-10 mb-5"
            :prepend-icon="'mdi-email'"
            placeholder="Email"
            hint="At least 8 characters"
          ></v-text-field>
          <v-divider class="mb-5"></v-divider>
          <v-btn text color="#5bc0de">Search</v-btn>
          <router-link :to="{ name: 'Login' }">
            <v-btn text>Cancel</v-btn></router-link
          >
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PasswordRecovery",
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters({
      //loginDetails: 'getUser',
    })
  },
  methods: {
    logout() {
      //this.$store.dispatch('logoutUser');
      //this.$router.push({name: 'Home' })
    }
  }
};
</script>

<style></style>
